import { Amplify, Auth } from 'aws-amplify'

const SignUp = async (username, password, optionalAttributes = {}) => {
  try {
    const { user } = await Auth.signUp({
      username,
      password,
      attributes: {
        'custom:accountUpdates': 'true',
        'custom:activeProductAlerts': 'true',
        'custom:insuranceSavings': 'true',
        ...optionalAttributes,
      },
    })
    return user
  } catch (e) {
    console.log(`error ${JSON.stringify(e)}`)
    throw e
  }
}

export default SignUp
